import { QueryClient, useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import { Page } from 'shared-types';

export const getSpaTreatmentsPage = async (propertyId: number, language: string) => {
  const { data } = await request.get(`${propertyId}/pages/spa-treatments/${language}`);
  return data as Page;
};

export function useGetSpaTreatmentsPage(propertyId: number, language: string, enabled = true) {
  return useQuery({
    queryKey: getSpaTreatmentsPageKey(propertyId, language),
    queryFn: () => getSpaTreatmentsPage(propertyId, language),
    enabled,
  });
}

export const getSpaTreatmentsPagePrefetch = async (
  queryClient: QueryClient,
  propertyId: number,
  language: string
) => {
  await queryClient.prefetchQuery(getSpaTreatmentsPageKey(propertyId, language), () =>
    getSpaTreatmentsPage(propertyId, language)
  );
};

export const getSpaTreatmentsPageKey = (propertyId: number, language: string) => [
  'spaTreatmentsPage',
  propertyId,
  language,
];
